<style lang="scss">
  @import 'chart-move.scss';
</style>
<template>
    <div class="app-chart">

        <div v-show="showTransform" class="app-chart-type">
            <span class="iconfont icon-curve tm-icon-font app-chart-type-icon" @click="tableChart('c')">
              <span class="path1" :class="transformType ? 'path': 'nopath'"></span>
              <span class="path2" :class="transformType ? 'path': 'nopath'"></span>
            </span>
            <span class="iconfont icon-form tm-icon-font app-chart-type-icon" :style="{ color: !transformType? '#5cadff':'#BDC5D5'}" @click="tableChart('t')"></span>
        </div>
        <!-- 图表 -->
        <div :class="transformType? 'chart-move':'hideChart'">
            <div class="chart-move-metrice">
                <slot name="chart-move-metrice"></slot>
            </div>
            <div class="chart-move-charts">
                <Spin v-show="spinShow" fix>
                    <Icon v-show="noDataInfo === ''" type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                    <div>{{ noDataInfo === '' ? lodingInfo : noDataInfo }}</div>
                </Spin>
                <div class="chart-move-charts-c" ref="area"></div>
            </div>
        </div>
        <!-- 表格 -->
        <div :class="transformType? 'hideChart':'table-move'">
            <Spin v-if="noData" fix>
                <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                <div>{{ lodingInfo }}</div>
            </Spin>
            <table-move :padding-bottom='10' ref="table"></table-move>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts';
import numberSeparator from '../../filters/number-separator';
import percent from '../../filters/percent-formate';
import numberToTime from '../../filters/number-to-time';
import tableMove from './table-move';
import ln from '../../libs/locale';
import bus from '../../libs/bus';

export default {
  props: {
    showTransform: {
      type: Boolean,
      default: false,
    },
    chartName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      myChart: '',
      chartData: {},
      saveTableColumn: {},
      spinShow: true,
      lineName: [],
      noData: true,
      transformType: true,
      noDataInfo: '',
      lodingInfo: ln[bus.lang].common.loading,
      indexName: [],
    };
  },
  computed: {

  },
  components: {
    tableMove,
  },
  filters: {
    numberSeparator,
    numberToTime,
  },
  mounted() {
    const self = this;
    bus.$on('on-change-lang', self.changeLang);
    window.addEventListener('resize', this.myChartResize, false);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.myChartResize, false);
    bus.$off('on-change-lang', this.changeLang);
    if (this.myChart) {
      this.myChart.dispose();
    }
  },
  methods: {
    changeLang() {
      const self = this;
      const objData = self.saveTableColumn;
      if (!this.noData) {
        const columns = this.setTableColumn(objData.res, objData.time, objData.user);
        self.$refs.table.tableColumns = columns;
      }
    },
    myChartResize() {
      if (this.myChart) {
        this.myChart.resize();
      }
    },
    resizeChart() {
      const self = this;
      if (self.transformType && self.chartData.series) {
        this.myChart = echarts.init(this.$refs.area);
        self.initChart(self.chartData, self.lineName);
      }
    },
    initChart(val, name) {
      const option = {
        color: ['#1495EB', '#00CC66', '#F9D249', '#ff9900', '#9860DF'],
        legend: {
          right: 5,
          top: 0,
          itemWidth: 16,
          itemHeight: 4,
          itemGap: 12,
          icon: 'roundRect',
          data: name,
          textStyle: {
            color: '#464c5b',
          },
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#FFF',
          borderColor: '#C3CBD6',
          borderWidth: 1,
          axisPointer: {
            lineStyle: {
              color: '#C3CBD6',
            },
          },
          padding: [0, 10],
          formatter: (a) => {
            let formatterStr = '';
            for (let i = 0; i < a.length; i += 1) {
              const keep = a[i].seriesName === this.$t('chartview.keepuser.oneday')
                || a[i].seriesName === this.$t('chartview.keepuser.month')
                || a[i].seriesName === this.$t('chartview.keepuser.week') ? '%' : '';
              // 多条折线时：当时间title一样时只显示一遍，不同时分别显示；TODO
              let titleTemp = '';
              if (i < 1) {
                titleTemp = `<h3 class="formatter-title">${a[i].name}</h3>`;
              } else {
                titleTemp = a[i].name === a[i - 1].name ? '' : `<h3 class="formatter-title">${a[i].name}</h3>`;
              }
              formatterStr += `${titleTemp}
                <p class='formatter-content'>
                  <span class="formatter-content-legend" style="background: ${a[i].color};"></span>
                  <span>${a[i].seriesName}</span>
                  <b>
                    ${a[i].value === undefined ? '--' : numberSeparator(a[i].value)}${keep}
                  </b>
                </p>`;
            }
            return formatterStr;
          },
        },
        grid: {
          left: 10,
          right: 25,
          bottom: 5,
          top: 45,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#D7DDE4',
              },
            },
            axisTick: {
              alignWithLabel: true,
              lineStyle: {
                color: '#D7DDE4',
              },
            },
            axisLabel: {
              textStyle: {
                color: '#7F8B9C',
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#F5F7F9',
              },
            },
            data: val.time,
          },
          {
            type: 'category',
            show: false,
            data: this.indexName,
          },
          {
            type: 'category',
            show: false,
            data: this.indexName,
          },
          {
            type: 'category',
            show: false,
            data: this.indexName,
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: '#FFFFFF',
                width: 2,
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#F5F7F9',
              },
            },
            axisLabel: {
              textStyle: {
                color: '#7F8B9C',
              },
              formatter(a) {
                const keep = name.indexOf(ln[bus.lang].chartview.keepuser.oneday) > -1 ? '%' : '';
                return `${a}${keep}`;
              },
            },
          },
        ],
        series: val.series,
      };
      this.$set(this.$data, 'spinShow', false);
      if (this.$refs.area != null) {
        this.myChart = echarts.init(this.$refs.area);
        this.myChart.setOption(option, true);
      }
    },
    // 表格表头处理
    setTableColumn(res, time, user) {
      this.saveTableColumn = {
        res,
        time,
        user,
      };
      const name = ln[bus.lang].chartview[user];
      const columns = [];

      Object.keys(res).forEach((keys) => {
        const w = keys === 'oneday' || keys === 'month' || keys === 'week' ? undefined : 300;
        columns.push({
          title: name[keys] || name.name,
          key: keys,
          sortable: 'custom',
          width: w,
          align: 'right',
          render(h, params) {
            const row = params.row;
            if (keys === 'month' || keys === 'week') {
              return [row[keys] === undefined ? '' : row[keys]];
            }
            return h('p', row[keys] === undefined ? '--' : numberSeparator(row[keys]));
          },
        });
      });

      if (time === 'hour') {
        columns.unshift({
          title: ln[bus.lang].chartview.range,
          key: 'hour',
          sortable: true,
          align: 'left',
          width: 120,
          ellipsis: true,
        });
      } else if (time === 'day') {
        columns.unshift({
          title: ln[bus.lang].keepuser.date,
          key: 'day',
          sortable: true,
          align: 'left',
          width: 120,
          ellipsis: true,
        });
      } else if (time === 'partnerid') {
        columns.unshift({
          title: ln[bus.lang].keepuser.date,
          key: 'partnerid',
          sortable: true,
          align: 'left',
          width: 120,
          ellipsis: true,
        });
      }
      columns.push({
        align: 'left',
        renderHeader(h) {
          return h('p', {
            style: {
              color: '#FFF',
            },
          });
        },
        render() {
          return '';
        },
      });
      return columns;
    },
    // 应用概览 图表表格数据整理
    setChartsData(res, time, user, avgData, avg) {
      const chart = {
        time: [],
        series: [],
      };
      const table = {
        columns: this.setTableColumn(res, time, user),
        data: [],
      };
      const line = [];
      const name = user === 'average' ?
      ln[bus.lang].chartview.startups : ln[bus.lang].chartview[user];
      const area = '';
      Object.keys(res).forEach((keys) => {
        const value = [];
        const item = res[keys];
        let tableValue = [];
        if (avg) {
          for (let i = 0; i < item.length; i += 1) {
            const number = (item[i][user] / avgData[i][avg]) * 100;
            const perNumber = percent(number) === 'N/A' ? '0.00' : percent(number);
            const tablePer = percent(number, true) === 'N/A' ? '0.00%' : percent(number, true);
            if (chart.time.indexOf(item[i][time]) === -1) chart.time.push(item[i][time]);
            value.push(perNumber);
            tableValue.push(tablePer);
          }
        } else {
          for (let i = 0; i < item.length; i += 1) {
            if (chart.time.indexOf(item[i][time]) === -1) {
              chart.time.push(item[i][time]);
            }
            value.push(item[i][user]);
            if (user === 'onetime' || user === 'usetime') {
              tableValue.push(numberToTime(item[i][user]));
            } else {
              tableValue = value;
            }
          }
        }
        line.push(name[keys]);
        chart.series.push({
          type: 'line',
          data: value,
          smooth: true,
          showSymbol: value.length === 1,
          name: name[keys],
        });
        for (let i = 0; i < tableValue.length; i += 1) {
          if (table.data[i] === undefined) {
            table.data.push({
              [time]: chart.time[i],
              [keys]: tableValue[i],
            });
          } else {
            table.data[i][keys] = tableValue[i];
          }
        }
      });

      this.setToTable(table);
      this.chartData = chart;
      this.lineName = line;
      this.$set(this.$data, 'spinShow', false);
      if (this.transformType) {
        this.initChart(this.chartData, this.lineName);
      }
    },
    // 添加图表数据
    addChartData(res, time, user, avgData, avg) {
      const chart = this.chartData;
      const table = {
        data: JSON.parse(this.$refs.table.saveTableData),
      };
      const name = ln[bus.lang].chartview[user];
      Object.keys(res).forEach((keys) => {
        const value = [];
        const item = res[keys];
        const tableValue = [];
        for (let i = 0; i < item.length; i += 1) {
          const number = (item[i][user] / avgData[i][avg]) * 100;
          const perNumber = percent(number) === 'N/A' ? '0.00' : percent(number);
          const tablePer = percent(number, true) === 'N/A' ? '0.00%' : percent(number, true);
          value.push(perNumber);
          tableValue.push(tablePer);
        }
        for (let i = 0; i < chart.series.length; i += 1) {
          if (name[keys] === chart.series[i].name) {
            chart.series[i].data = value;
          }
        }
        for (let i = 0; i < tableValue.length; i += 1) {
          table.data[i][keys] = tableValue[i];
        }
      });
      this.setToTable(table);
      this.chartData = chart;
      this.$set(this.$data, 'spinShow', false);
      this.initChart(this.chartData, this.lineName);
    },
    // 渠道分析 图表数据整理
    setChannelData(time, res, user, partnerName) {
      const chart = {
        time: [],
        series: [],
      };
      const line = [];
      const channelId = [];
      Object.keys(res).forEach((item) => {
        const value = [];
        for (let i = 0; i < res[item].length; i += 1) {
          if (chart.time.indexOf(res[item][i][time]) === -1) chart.time.push(res[item][i][time]);
          value.push(res[item][i][user]);
          channelId.push(res[item][i].partnerid);
        }
        chart.series.push({
          type: 'line',
          data: value,
          smooth: true,
          showSymbol: value.length === 1,
          name: partnerName[item],
        });
        line.push(partnerName[item]);
      });

      this.lineName = line;
      this.chartData = chart;
      this.$set(this.$data, 'spinShow', false);
      if (this.transformType) {
        this.initChart(this.chartData, this.lineName);
      }
    },
    // 设置表格数据
    setToTable(data) {
      this.$set(this.$data, 'noData', false);
      const table = this.$refs.table;
      if (data.columns) table.tableColumns = data.columns;
      table.saveTableData = JSON.stringify(data.data);
      table.changeData = data.data;
      table.tableData = table.mockTableData(1, data.data);
    },
    // 导出表格
    exportTable(name) {
      this.$refs.table.exportTable(name);
    },
    clearData() {
      const self = this;
      self.$set(this.$data, 'chartData', {});
      self.$set(this.$data, 'lineName', []);
      self.$set(self.$data, 'indexName', []);
      self.$set(this.$data, 'spinShow', true);
      self.$set(this.$data, 'noData', true);
      self.$set(this.$data, 'noDataInfo', '');
      self.$set(this.$data, 'transformType', true);
      if (self.myChart) {
        self.myChart.dispose();
      }
    },
    nothingData() {
      if (this.$refs.area != null) this.$set(this.$data, 'spinShow', false);
    },
    // 图表 表格转化
    tableChart(str) {
      this.transformType = str === 'c';
      this.$emit('on-change-chart-type', this.chartName, this.transformType);
    },
  },
};
</script>
